import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "产品与服务", -1)
const _hoisted_3 = { class: "content-serve-row-text" }
const _hoisted_4 = { style: {"padding":"0 10px","text-align":"left","text-indent":"0em","overflow":"hidden","display":"-webkit-box","-webkit-line-clamp":"3","-webkit-box-orient":"vertical","word-break":"break-all","min-height":"51px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "grid-content" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "法苑在线律师"),
  /*#__PURE__*/_createElementVNode("h6", null, "专业提供中小企业法律服务")
], -1)
const _hoisted_6 = { class: "grid-content" }
const _hoisted_7 = {
  class: "content-partner",
  ref: "menu3"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", null, "法苑在线律师团", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["onMouseover"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["onMouseover"]
const _hoisted_13 = {
  class: "content-services",
  ref: "menu4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", null, "企业入驻", -1)
const _hoisted_15 = { class: "grid-content" }
const _hoisted_16 = { style: {"padding":"0 10px"} }
const _hoisted_17 = { style: {"display":"flex","margin-bottom":"20px"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"114px","line-height":"90px","font-weight":"600","font-size":"16px","text-align":"right"} }, "梦乾科技", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"114px","line-height":"90px","font-weight":"600","font-size":"16px","text-align":"left"} }, "指定法律服务商", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { style: {"padding":"0 10px","margin-top":"2px"} }, "中国电子商会部分会员名单", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "content-services-spanText" }, " 法苑在线律师团高端法律服务 ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "content-services-spanText" }, " 作为新一代的互联网化的法律服务机构 ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "content-services-spanText" }, " 能为公司客户在日常经营、公司治理和商务活动提供广泛的高级法律服务 ", -1)
const _hoisted_24 = {
  class: "content-webinar",
  ref: "menu5"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h1", null, "法律培训", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 专业化的实务培训服务，系列线上和线下课"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"600","font-size":"17px","color":"#f6bf48"} }, "内容包括必备技能、核心技能、出庭、案例研习、模拟法庭五大类课程"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("助力律师从基础到进阶，从理论到实务，全方位提升法律专业能力 ")
], -1)
const _hoisted_27 = { class: "content-webinar-moudle2" }
const _hoisted_28 = { class: "grid-content" }
const _hoisted_29 = { class: "content-webinar-row-text" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { style: {"text-align":"left","position":"relative","padding":"0 5%","height":"88px"} }
const _hoisted_32 = { style: {"margin-bottom":"7px"} }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "xs_title"
}
const _hoisted_35 = {
  class: "content-center-blue content-combo",
  ref: "menu6"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h1", null, "服务套餐", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "content-combo-bottom" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h1", null, "关于我们", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "content-aboutUs-text" }, [
  /*#__PURE__*/_createTextVNode("     北京梦乾科技有限公司是专业法律服务产品研发、法律服务资源整合、在线法律服务运营的互联网科技企业，构建了强大的产品研发团队，应用大数据、人工智能和云计算技术，在法律服务和法律科技领域积极探索，致力于向中小企业提供专业、高效、全方位的法律服务，基于专业法律服务的基因，借助互联网和先进信息技术，构建更加公平正义的综合性法律服务互联网平台。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("     公司旗下主要运营网页版“法苑在线”、小程序和公众号“i法苑”，为中小企业和律师/律所提供即时高效的专业法律服务平台。通过线上音视频沟通和线下约见相结合、线上签约、在线付费等方式，解决互联网时代法律服务即时通讯需求和专业高效的法律服务需要，致力于打造新时代的更为专业的互联网法律服务企业。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("    商务合作：手机：13671344225 微信:ify12348 ")
], -1)
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]

import {
		ChatLineRound,
		Edit,
		Service,
		User,
		More,
		Connection,
	} from "@element-plus/icons-vue";
	import { watch, getCurrentInstance, reactive, ref, onMounted } from "vue";
	import type { FormInstance, FormRules } from "element-plus";
	const formLabelWidth = "140px";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'content',
  props: {
		parentMenu: {
			type: String,
			default: "1",
		},
	},
  setup(__props) {

	const contentImg = require("@/assets/banner/law-content-img.jpg");
	const bannerImg = require("@/assets/banner/banner.jpg");
	const qrCodeImg = require("@/assets/img/qr-code.jpg")
	const CoceralImg = require("@/assets/banner/WechatIMG29796.jpg")

	// 是否显示培训模块标题
	const showTrainTitle = ref(false);
	const showTrainIndex = ref(0);
	// 产品与服务
	const serveList = reactive<Array>([
		{
			title: "常年法律顾问",
			img: "https://cdn.fy12348.cn/webpc/banner/falvguwen1.jpg",
			content:
				"一站式为中小企业提供全方位、专业化的法律服务，通过事前审查预防、事中防范控制、事后有效救济，全方面解决中小企业常年法律服务需求",
		},
		{
			title: "视频/语音咨询",
			img: "https://cdn.fy12348.cn/webpc/services/yuyin111webp.webp",
			content: "中小企业法务、负责人与律师线上视频面对面，洽谈更直观、沟通更方便",
		},
		{
			title: "在线签约",
			img: "https://cdn.fy12348.cn/webpc/banner/d904e614be5e4b5.jpg?a=1",
			content:
				"公司与e签宝合作，“签署更便捷，信任更简单”，为企业与律师/律所提供线上法律认证和签约服务",
		},
		{
			title: "渠道合作",
			img: "https://cdn.fy12348.cn/webpc/services/qudaohezuo.webp",
			content:
				"渠道方企业会员尊享市场价值5万元的专项法律服务；非渠道方会员，专享价9998元。品控经理为您优选专业领域律师",
		},
		{
			title: "法律培训",
			img: "https://cdn.fy12348.cn/webpc/services/falvpeixun.jpg",
			content:
				"专业化的实务培训服务，助力律师从基础到进阶，从理论到实务，全方位提升法律专业能力",
		},
		{
			title: "企业法律需求解决方案",
			img: "https://cdn.fy12348.cn/webpc/banner/serve-mini-banner.png",
			content:
				"全面法律风险体检,内部法律培训,企业法律咨询,起草/审查合同,专项法律意见书,律师函/商务沟通函,诉讼及仲裁",
		},
	]);
	//律师列表
	const list = reactive<Array>([
		[
			{
				content:
					"专业领域：金融政策及金融业运营规则 重大疑难复杂金融案件。<br>职业履历：主任律师、北京市某法院法官、中国国际经济贸易委员会仲裁员、北海国际仲裁院仲裁员、中央电视台特约法律评论专家。",
				name: "杨毅律师",
				intro: "北京睦湃律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/yangyi.png",
			},
			{
				content:
					"专业领域：公司综合类业务、企业合规及法律风险管理、并购重组、投融资、私募基金、商事合同、纠纷处理等。<br>职业履历：主任律师，北京市物权法研究会副会长兼秘书长，北京市律师协会物权法专业委员会主任，北京市律师协会监事、海淀区律师协会监事长，“大爱清尘”公益基金监事，CCTV《律师来了》人气律师。",
				name: "毕文强律师",
				intro: "北京市盛廷律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/biwenqiang.png",
			},
			{
				content:
					"专业领域：公司综合类业务、企业合规及法律风险管理、并购重组、投融资、私募基金、商事合同、纠纷处理等。<br>职业履历：北京睦派律师事务所创始合伙人、国融证券私募基金合规风控负责人、中泰创展内控经理、中植集团投资银行部副总经理、宝瑞通典当行法务经理。",
				name: "孟朝领律师",
				intro: "北京睦湃律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/mengchaolin.png",
			},
		],
		[
			{
				content:
					"职业领域：刑事辩护、企业合规及法律风险管理、常年法律顾问、投融资、民商事争议解决等。<br>职业履历：曾任某中央司法机关机关报编辑、记者；某央企集团董事会办公室主任；北京知行法律实务研究中心理事等。",
				name: "王金贵律师",
				intro: "北京市中闻律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/wangjingui.png",
			},
			{
				content:
					"职业领域：刑事辩护、企业合规及法律风险管理、常年法律顾问、投融资、民商事争议解决等。<br>职业履历：曾任某中央司法机关机关报编辑、记者；某央企集团董事会办公室主任；北京知行法律实务研究中心理事等。",
				name: "魏汝久律师",
				intro: "北京魏汝久律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/weirujiu.png",
			},
			{
				content:
					"职业领域：刑事辩护、企业合规及法律风险管理、常年法律顾问、投融资、民商事争议解决等。<br>职业履历：曾任某中央司法机关机关报编辑、记者；某央企集团董事会办公室主任；北京知行法律实务研究中心理事等。",
				name: "郭爱军律师",
				intro: "北京市中盾律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/guoaijun.png",
			},
		],
		[
			{
				content:
					"中同律师事务所创始合伙人、主任武汉大学法学学士、中国人民大学刑法学硕士。师从著名刑法学家马克昌、高铭暄、王作富教授。现任中华全国律师协会企业合规法律专业委员会委员、北京企业法律风险防控研究会涉企疑难案件专家咨询委员会副主任。<br/>荣获“全国律师行业优秀党员”、“全国优秀律师”、“第七届中国时代十大卓越人物”、“2010年度中国律师界新闻人物”、“北京市优秀律师”、“北京市司法行政系统先进个人”、“北京市百名刑辩律师”、西城区首届“十佳律师”等多项荣誉称号。",
				name: "杨矿生律师",
				intro: "北京市中同律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/yangkuangsheng.png",
			},
			{
				content:
					"专业领域：死刑复核、毒品犯罪、食品药品犯罪、环境犯罪、涉税犯罪、非法经营犯罪、刑事申诉等重大刑事疑难案件。毕业于中国政法大学，现任北京市京都律师事务所食品药品法律研究中心主任，北京市律协刑事诉讼专业委员会委员，北京犯罪学研究会会员，中国药物滥用防治协会会员，中国刑法学研究会会员，2022年度《法治日报》律师专家库成员，2023年度美国国务院“IVLP”项目参访者，荣获《法制晚报》2017年度“公益普法奖",
				name: "汤建彬律师",
				intro: "北京京都律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/tangjianbin.jpg",
			},
			{
				content:
					"专业领域：公司业务、改制并购破产重整、清算、房地产业务。职业履历：北京大成律师事务所高级合伙人，现任大成总部破产重整与清算专业组负责人、大成全球债务重组及破产重整团队领导人、大成业务一部主任、国际破产法协会会 员、北京市破产法学会监事、北京市青联第十一届委员会委员、北京市东城区青联委员会第六届常委，国务院国资委《国有企业依法破产实务研究课题》执笔人，具有独立董事资格，任部分政府整体风险处置的专项顾问，2021 年出版著作《破产诉讼案件裁判规则与管理人实务》。由于在债务重组及破产业务方面的突出表现，获选 2018 ALB China十五佳女律师，荣登2020年度《商法》中国市场“TheA-List 法律精英”榜单，The Legal 500 2021亚太地区反垄断与竞争法、公司与并购入选推荐律师，The Legal 500 2022亚太地区破产重组、 税务领域特别推荐律师，2022年度LEGALBAND中国律师特别推荐榜 15强：债务重组，2023年度LEGALBAND破产重组推荐律师。",
				name: "高美丽律师",
				intro: "北京大成律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/gaomeili.jpg",
			},
		],
		[
			{
				content:
					"蒙古国法律服务、中国大陆国有土地使用权、农村集体土地承包经营权、矿产资源勘探开采权、不动产登记。",
				name: "嘎础拉律师",
				intro: "内蒙古秀友律师事务所",
				imgurl: "https://cdn.fy12348.cn/lawyer/gachula.jpg",
			},
		]
	]);
	const enterpriseList = [
		{ icon: "", name: "北京北创网联科技股份有限公司" },
		{ icon: "", name: "北京宝瑞通典当行有限责任公司" },
		{ icon: "", name: "江西英婷科技有限公司" },
		{ icon: "", name: "优百佳车（北京）汽车销售有限公司" },
		{ icon: "", name: "云南君弘信息咨询有限公司" },
		{ icon: "", name: "云南圣融矿业集团有限公司" },
		{ icon: "", name: "北京兴荣华会计师事务所" },
		{ icon: "", name: "萌豆财税服务（天津）有限公司" },
		{ icon: "https://cdn.fy12348.cn/icons/group/ceie.png", name: "中国电子商会信息工程测试专业委员会" },
		{ icon: "https://cdn.fy12348.cn/icons/group/dsxk.png", name: "电设信科（北京）技术有限公司" },
		{ icon: "https://cdn.fy12348.cn/icons/group/guoruijoint.png", name: "北京国锐联合科技有限公司" },
		{ icon: "https://cdn.fy12348.cn/icons/group/stlawlogo.png", name: "北京市盛廷律师事务所" },
		{ icon: "https://cdn.fy12348.cn/icons/group/wyfwpgjlhlogo.png", name: "北京市物业服务评估监理协会" },
		{ icon: "https://cdn.fy12348.cn/icons/group/cjbdi.png", name: "中国司法大数据研究院" },
		{ icon: "https://cdn.fy12348.cn/icons/group/bjjxshlogo.png", name: "北京江西企业商会" },
	];

	// 法律培训
	const trainList = reactive<Array>([
		{
			url: require("@/assets/img/statement.jpg"),
			title: "法官说法",
			content:
				"刑事、民事、行政等领域的法官现身讲法。法官用生动的案例、亲切的对话、理论联系实际，解决疑难问题，掌握处理办法。律师和企业负责人与法官面对面，全新视角，耳目一新",
		},
		{
			url: require("@/assets/img/practice.jpg"),
			title: "律师实务",
			content:
				"专家律师解析案例、结合实战，针对性的提供可操作性的建议，给予企业负责人和年轻律师实务性、可操作性强的专业指导",
		},
		{
			url: require("@/assets/img/celebrity.jpg"),
			title: "名人视角",
			content:
				"汇聚各高等院校、离任大法官、行业专家等精英群体，通过直播、线上线下讲座等方式，高屋建瓴、深入浅出地分析法律热点、行业前瞻",
		},
		{
			url: require("@/assets/img/celebrity.jpg"),
			title: "名人视角",
			content:
				"汇聚各高等院校、离任大法官、行业专家等精英群体，通过直播、线上线下讲座等方式，高屋建瓴、深入浅出地分析法律热点、行业前瞻",
		},  {
			url: require("@/assets/img/image-2.jpg"),
			title: "律师实务",
			content:
				"i法苑作为电子商会指定服务商参加大湾区专精特新发展论坛",
		},{
			url: require("@/assets/img/image-1.jpg"),
			title: "名人视角",
			content:
				"（筑梦新区）大湾区专精特新与科技创新发展论坛在中山举行",
		},
	]);
	// 鼠标滑过显示当前块的索引

	const showTrainHover = (index) => {
		showTrainTitle.value = true;
		showTrainIndex.value = index;
	}
	const partnerArr = [];
	const childMenu = __props;
	const menuArr = getCurrentInstance();
	watch(
		() => childMenu.parentMenu,
		(newValue, oldValue) => {
			if (menuArr) {
				for (const i in menuArr.refs) {
					if (i == "menu" + newValue) {
						menuArr.refs[i].scrollIntoView({
							block: "start",
							behavior: "smooth",
						});
					}
				}
			}
		}
	);
	const comboScroll = () => {
		menuArr.refs["menu6"].scrollIntoView({
			block: "start",
			behavior: "smooth",
		});
	};
	//商会
	const dialogFormVisibleCoceral=ref<boolean>(false);
	const CoceralFun=()=>{
		dialogFormVisibleCoceral.value=true
	}
	//弹窗
	const dialogFormVisible = ref<boolean>(false);
	const ruleFormRef = ref<FormInstance>();
	const form = reactive({
		name: "",
		phone: "",
		desc: "",
	});
	const rules = reactive<FormRules>({
		name: [
			{ required: true, message: "请输入姓名", trigger: "blur" },
			{ min: 3, max: 5, message: "长度为3-5", trigger: "blur" },
		],
		phone: [
			{ required: true, message: "请输入电话", trigger: "blur" },
			{ min: 8, max: 11, message: "长度为8或11", trigger: "blur" },
		],
	});
	const submitForm = async (formEl : FormInstance | undefined) => {
		if (!formEl) return;
		await formEl.validate((valid, fields) => {
			if (valid) {
				console.log("submit!");
				dialogFormVisible.value = false;
			} else {
				console.log("error submit!", fields);
			}
		});
	};

	//律师入驻鼠标时间
	const hoverIndex = ref<string>("0");
	const lawMouseover = (index : number, indexChild : number) => {
		hoverIndex.value = `${index}-${indexChild}`;
		console.log(hoverIndex);
	};
	const resetForm = (formEl : FormInstance | undefined) => {
		if (!formEl) return;
		formEl.resetFields();
	};
	//判断是大屏还是小屏
	let ismx = ref<boolean>()
	const scrollWidth = ref<number>(0)
	const widthHandle = () => {
		scrollWidth.value = document.body.clientWidth; //滚动条距离浏览器顶部高度

	};
	onMounted(() => {
		widthHandle()
		if (scrollWidth.value > 1299) {
			ismx.value = true
		} else {
			ismx.value = false
		}
		window.addEventListener("resize", widthHandle);
	});
	watch(
		() => scrollWidth.value,
		(newValue, oldValue) => {
			console.log(newValue, oldValue)
			setTimeout(() => {
				if (newValue > 1299) {
					ismx.value = true
				} else {
					ismx.value = false
				}
			}, 20); // 需要使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms

		}
	)

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(ismx)==true?'banner':'banner banner2']),
      m: "t-4",
      ref: "menu1"
    }, [
      _createVNode(_component_el_image, {
        style: {"width":"100%","height":"100%"},
        src: _unref(bannerImg)
      }, null, 8, ["src"]),
      _createVNode(_component_el_image, {
        class: _normalizeClass([_unref(ismx)==!true?'qr_code_img':'qr_code_img qr_code_img_pc']),
        src: _unref(qrCodeImg),
        fit: "fill"
      }, null, 8, ["class", "src"]),
      _createVNode(_component_el_button, {
        type: "primary",
        style: {"position":"absolute","bottom":"0.2rem","width":"150px","max-height":"50px","min-height":"30px","height":"4vh","left":"0","right":"0","margin":"auto"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogFormVisible.value = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 立即咨询 ")
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(ismx)==true?'content-serve':'content-serve2']),
      ref: "menu2"
    }, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass([_unref(ismx)==true?'content-serve-row':'content-serve2-row'])
      }, [
        _createVNode(_component_el_row, {
          gutter: 68,
          class: _normalizeClass([_unref(ismx)==true?'content-serve-row-outer':'content-serve2-row-outer'])
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serveList, (o, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                key: index,
                lg: 8,
                md: 8,
                sm: 12,
                xs: 24
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, {
                    "body-style": { padding: '0px' },
                    class: _normalizeClass([_unref(ismx)==true?'content-serve-row-card':'content-serve2-row-card'])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        style: {"width":"100%","height":"2rem"},
                        src: o.img
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_3, _toDisplayString(o.title), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_4, _toDisplayString(o.content), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["class"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([_unref(ismx)==true?'content-center-blue':'content-center-blue2']),
        ref: "menu3"
      }, [
        _createVNode(_component_el_image, {
          style: {"width":"100%","height":"200px"},
          src: require('@/assets/banner/center-banner-blue.png')
        }, null, 8, ["src"]),
        _createElementVNode("div", {
          class: _normalizeClass([_unref(ismx)==true?'content-center-blue-text':'content-center-blue2-text'])
        }, [
          _createVNode(_component_el_row, { gutter: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                md: 16,
                sm: 24
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                md: 8,
                sm: 24
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogFormVisible.value = true)),
                      style: {"width":"150px","max-height":"50px","height":"0.6rem","color":"#3296fa"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 申请入驻 ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 2)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      (_unref(ismx))
        ? (_openBlock(), _createBlock(_component_el_carousel, {
            key: 0,
            height: "400px"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, {
                  key: item,
                  "pause-on-hover": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (itemChild, indexChild) => {
                          return (_openBlock(), _createBlock(_component_el_col, {
                            sm: 8,
                            xs: 24,
                            key: itemChild
                          }, {
                            default: _withCtx(() => [
                              (hoverIndex.value == `${index}-${indexChild}`)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "grid-content",
                                    onMouseout: _cache[2] || (_cache[2] = ($event: any) => (hoverIndex.value = '0'))
                                  }, [
                                    _createElementVNode("h3", null, _toDisplayString(itemChild.name), 1),
                                    _createElementVNode("p", {
                                      style: {"padding":"0 20px","text-align":"left","line-height":"1.6em"},
                                      innerHTML: itemChild.content
                                    }, null, 8, _hoisted_9)
                                  ], 32))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "grid-content",
                                    onMouseover: ($event: any) => (lawMouseover(index, indexChild))
                                  }, [
                                    _createVNode(_component_el_image, {
                                      style: {
                    width: '150px',
                    height: '150px',
                    'border-radius': '100%',
                    'margin-bottom': '10px',
                  },
                                      src: itemChild.imgurl
                                    }, null, 8, ["src"]),
                                    _createElementVNode("h3", null, _toDisplayString(itemChild.name), 1),
                                    _createElementVNode("p", null, _toDisplayString(itemChild.intro), 1)
                                  ], 40, _hoisted_10))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(ismx))
        ? (_openBlock(), _createBlock(_component_el_carousel, {
            key: 1,
            height: "4rem",
            class: "xs_carousel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      "pause-on-hover": false,
                      style: {"height":"335px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (itemChild, indexChild) => {
                        return (_openBlock(), _createBlock(_component_el_col, {
                          sm: 8,
                          xs: 24,
                          key: itemChild
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_carousel_item, null, {
                              default: _withCtx(() => [
                                (hoverIndex.value == `${index}-${indexChild}`)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "grid-content",
                                      onMouseout: _cache[3] || (_cache[3] = ($event: any) => (hoverIndex.value = '0'))
                                    }, [
                                      _createElementVNode("h3", null, _toDisplayString(itemChild.name), 1),
                                      _createElementVNode("p", {
                                        style: {"padding":"0 20px","text-align":"left","line-height":"1.6em"},
                                        innerHTML: itemChild.content
                                      }, null, 8, _hoisted_11)
                                    ], 32))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "grid-content",
                                      onMouseover: ($event: any) => (lawMouseover(index, indexChild))
                                    }, [
                                      _createVNode(_component_el_image, {
                                        style: {
                    width: '150px',
                    height: '150px',
                    'border-radius': '100%',
                    'margin-bottom': '10px',
                  },
                                        src: itemChild.imgurl
                                      }, null, 8, ["src"]),
                                      _createElementVNode("h3", null, _toDisplayString(itemChild.name), 1),
                                      _createElementVNode("p", null, _toDisplayString(itemChild.intro), 1)
                                    ], 40, _hoisted_12))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", {
        class: _normalizeClass([_unref(ismx)==true?'content-services-module':'content-services-module2'])
      }, [
        _createVNode(_component_el_row, { align: "middle" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(enterpriseList, (item, index) => {
              return _createVNode(_component_el_col, {
                sm: 6,
                xs: 12,
                key: index,
                class: _normalizeClass([_unref(ismx)==true?'content-services-module-col':'content-services-module2-col'])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    (item.icon === '')
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          style: {"width":"80px","height":"80px"},
                          src: require(`@/assets/banner/icon/icon${index + 1}.png`),
                          fit: "fill"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock(_component_el_image, {
                          key: 1,
                          style: {"width":"80px","height":"80px"},
                          src: item.icon,
                          fit: "fill"
                        }, null, 8, ["src"])),
                    _createElementVNode("h2", _hoisted_16, _toDisplayString(item.name), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["class"])
            }), 64))
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "grid-content",
          style: {"margin-bottom":"10px","width":"50%"},
          onMouseover: _cache[4] || (_cache[4] = ($event: any) => (dialogFormVisibleCoceral.value=true))
        }, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_image, {
              style: {"width":"90px","margin":"0 30px"},
              src: require(`@/assets/banner/icon/coceral-logo.jpg`),
              fit: "fill"
            }, null, 8, ["src"]),
            _hoisted_19
          ]),
          _hoisted_20
        ], 32)
      ], 2),
      _hoisted_21,
      _hoisted_22,
      _hoisted_23,
      _createVNode(_component_el_button, {
        type: "primary",
        style: {"margin":"10px auto","width":"150px","max-height":"50px","min-height":"30px","height":"4vh"},
        onClick: comboScroll
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 查看详情 ")
        ]),
        _: 1
      })
    ], 512),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_el_row, { gutter: 50 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trainList, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                sm: 8,
                xs: 24,
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_el_card, {
                      "body-style": {
                  padding: '30px 0 10px',
                  position: 'relative',
                },
                      onMouseover: ($event: any) => (showTrainHover(index)),
                      onMouseout: _cache[5] || (_cache[5] = ($event: any) => (showTrainTitle.value=false))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "content-webinar-img",
                          style: _normalizeStyle({
                    background: `url(${item.url}) no-repeat center center/cover`,
                  })
                        }, null, 4),
                        _createElementVNode("div", _hoisted_29, [
                          (showTrainTitle.value && index == showTrainIndex.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(item.title), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("h4", _hoisted_32, _toDisplayString(item.content), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onMouseover"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_image, {
        style: {"width":"100%","height":"180px"},
        src: require('@/assets/banner/banner4.png')
      }, null, 8, ["src"]),
      (_unref(ismx))
        ? (_openBlock(), _createElementBlock("h2", _hoisted_33, "法苑在线高端服务"))
        : _createCommentVNode("", true),
      (!_unref(ismx))
        ? (_openBlock(), _createElementBlock("p", _hoisted_34, "法苑在线高端服务"))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _createElementVNode("div", {
        class: _normalizeClass([_unref(ismx)==true?'content-combo-form':'content-combo-form2'])
      }, null, 2),
      _hoisted_37
    ], 512),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(ismx)==true?'content-aboutUs':'content-aboutUs content-aboutUs2']),
      ref: "menu7"
    }, _hoisted_40, 2),
    _createVNode(_component_el_dialog, {
      "align-center": "",
      modelValue: dialogFormVisibleCoceral.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogFormVisibleCoceral).value = $event)),
      width: "70%",
      onMouseout: _cache[7] || (_cache[7] = ($event: any) => (dialogFormVisibleCoceral.value=false)),
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_image, {
          class: "qr_code_img_div_coceral",
          src: _unref(CoceralImg),
          fit: "fill"
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      "align-center": "",
      modelValue: dialogFormVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogFormVisible).value = $event)),
      width: "550px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_image, {
          class: "qr_code_img_div",
          src: _unref(qrCodeImg),
          fit: "fill"
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})